/* ==========================================================================
   KALIDAS — Phase 4 nav enhancements
   - Sticky header avec backdrop blur on scroll (DS spec : 92% ivoire blur(12px))
   - aria-current="page" sur le lien correspondant à l'URL courante (a11y §1)
   ========================================================================== */

(function () {
  'use strict';

  // ── Sticky scroll state ──
  var nav = document.querySelector('.site-nav');
  if (nav) {
    var threshold = 20;
    var ticking = false;

    function onScroll() {
      if (!ticking) {
        window.requestAnimationFrame(function () {
          var scrolled = window.scrollY > threshold;
          nav.classList.toggle('is-scrolled', scrolled);
          ticking = false;
        });
        ticking = true;
      }
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  // ── Back-to-top button ──
  // Apparaît après 400px de scroll, click → smooth scroll vers le top.
  var btnTop = document.getElementById('backToTop');
  if (btnTop) {
    var showAt = 400;
    var btnTicking = false;

    function onScrollBtn() {
      if (!btnTicking) {
        window.requestAnimationFrame(function () {
          btnTop.classList.toggle('is-visible', window.scrollY > showAt);
          btnTicking = false;
        });
        btnTicking = true;
      }
    }

    window.addEventListener('scroll', onScrollBtn, { passive: true });
    onScrollBtn();

    btnTop.addEventListener('click', function () {
      var prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      window.scrollTo({
        top: 0,
        behavior: prefersReduced ? 'auto' : 'smooth'
      });
    });
  }

  // ── aria-current sur le lien actif ──
  var currentPath = window.location.pathname.replace(/\/$/, '') || '/';
  var navLinks = document.querySelectorAll('.site-nav .nav-link, .site-nav .nav-cta');
  navLinks.forEach(function (link) {
    var href = link.getAttribute('href') || '';
    // Skip anchor-only links (ex: #boutique) — pas pertinent pour aria-current
    if (href.indexOf('#') === 0) return;
    try {
      var linkPath = new URL(href, window.location.origin).pathname.replace(/\/$/, '') || '/';
      if (linkPath === currentPath) {
        link.setAttribute('aria-current', 'page');
      }
    } catch (e) {
      // ignore malformed URLs
    }
  });
})();
